export default __webpack_public_path__ + "static/media/img-slider-craft-2024-4.7cc759d2.png";